import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "constants/AuthConstant";

// Create axios instance
const apiCall = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

/**
 * Request Interceptor
 * Injects Authorization header unless skipAuth = true
 */
apiCall.interceptors.request.use(
  (config) => {
    // Skip auth header if requested
    if (config.skipAuth) {
      return config;
    }

    // SSR-safe check
    const token =
      typeof window !== "undefined"
        ? localStorage.getItem(AUTH_TOKEN)
        : null;

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Optional: Handle 401 globally
 */
apiCall.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;

    if (status === 401 || status === 403) {
      console.warn("🔐 Auth error — logout possible here");
      // Example:
      // localStorage.removeItem(AUTH_TOKEN);
      // window.location.href = "/login";
    }

    return Promise.reject(err);
  }
);

export default apiCall;
